import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoDomicilioEnum } from 'graphql/types.generated'

import { tipoDomicilioEnumRecord } from './condicoes-moradia-model'

type TipoDomicilioSelectFieldProps = CustomSelectFieldProps<TipoDomicilioEnum>

export function TipoDomicilioSelectField(props: TipoDomicilioSelectFieldProps) {
  return <SelectField<TipoDomicilioEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.keys(tipoDomicilioEnumRecord) as TipoDomicilioEnum[]
const itemToString = (item: TipoDomicilioEnum) => item && tipoDomicilioEnumRecord[item]
